import { FC } from "react";

import { type PresentationBannerColorType } from "components/footer/PresentationBanner";
import { t } from "i18n/i18n";
import { PillButton } from "mds/components/PillButton";

export type StopPresentingButtonProps = {
  color: PresentationBannerColorType;
  onStopPresenting: () => void;
  showShortText?: boolean;
  eventName?: string;
};

export const StopPresentingButton: FC<StopPresentingButtonProps> = ({
  color,
  onStopPresenting,
  showShortText,
  eventName,
}) => (
  <PillButton eventName={eventName} kind={`banner-${color}`} size="s" onClick={onStopPresenting}>
    {showShortText ? t("main_header.stop_short") : t("main_header.stop_presenting")}
  </PillButton>
);
